export const VEHICLE_TELEMETRY_NAMESPACE = '/vehicle/telemetry-v1';
export const MISSION_STATE_NAMESPACE = '/mission/state-v1';

const CHANNEL_NAMESPACES = [VEHICLE_TELEMETRY_NAMESPACE, MISSION_STATE_NAMESPACE] as const;

export type ChannelNamespace = (typeof CHANNEL_NAMESPACES)[number];

export const ALL_FLEETS = '*';

/** A trailing `*` matches every channel below the path, at any depth. */
export const fleetChannel = (namespace: ChannelNamespace, fleetId: string) =>
    fleetId === ALL_FLEETS ? `${namespace}/*` : `${namespace}/${fleetId}/*`;
